// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3xhGH","form":"styles_form__5bYbK"};